import { FileMimeType } from 'yo-services/yolabs/services/poplarfrontend/enums_pb';
import { isImageMimeType } from '@poplar/utils/file';
import { API_MEDIA_THUMBNAIL } from '@poplar/constants/routes';

/**
 * Crop an image based on the provided definition.
 *
 * @param image - the URL source of the image.
 * @param crop - the definition of how the image should be cropped.
 */
export function getCroppedImage(image, crop) {
  return new Promise(function (resolve, reject) {
    var canvas = document.createElement('canvas');
    var scaleX = image.naturalWidth / image.width;
    var scaleY = image.naturalHeight / image.height;
    canvas.width = Number(crop.width);
    canvas.height = Number(crop.height);
    var ctx = canvas.getContext('2d');

    if (!ctx) {
      return reject('Unable to get canvas context');
    } // asserting a lot of crop properties as we're forcing a selection via "keepSelection"
    // so they're guaranteed to be set


    ctx.drawImage(image, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, crop.height * scaleY, 0, 0, crop.width, crop.height);
    canvas.toBlob(function (blob) {
      if (blob) {
        return resolve(blob);
      }

      reject('Failed creating a blob from a canvas');
    }, 'image/jpeg', 1);
  });
}

/**
 * Gets image thumbnail for given conditions
 */
export var getImageThumbnail = function getImageThumbnail(mediaImageFile) {
  var fileMimeType = mediaImageFile.fileMimeType,
      proxy = mediaImageFile.proxy,
      fileUuid = mediaImageFile.fileUuid,
      thumbnail = mediaImageFile.thumbnail;

  if (isImageMimeType(fileMimeType) || fileMimeType === FileMimeType.FILE_MIME_TYPE_PDF) {
    var src = proxy ? "".concat(API_MEDIA_THUMBNAIL, "/").concat(fileUuid) : thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.url;
    return src ? {
      src: src
    } : undefined;
  }
};